const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNowhere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 19",
    id: "svg1229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1223"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient54",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44-9",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46-9",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    offset: 0.267,
    style: {
      stopOpacity: 0.15999084,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    offset: 0.539,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient78",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0.267,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0.539,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient118",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop116-1",
    offset: 1,
    style: {
      stopOpacity: 0.17000076,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient136",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop132",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop134",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowhere);
export default __webpack_public_path__ + "static/media/nowhere.5dea8928618bdf56832e0ecc4baa1a90.svg";
export { ForwardRef as ReactComponent };